<template>
<div :class="bem('footer')">
    <div :class="bem('left')" slot="agreement">
        登录即视为同意<a :href="`${gaodingUrl}/term/user_service`" target="_blank"> 用户服务协议</a>、<a :href="`${gaodingUrl}/term/privacy`" target="_blank"> 隐私政策</a>和<a :href="`${gaodingUrl}/term/license_agreement`" target="_blank"> 授权许可协议</a>。如果您成为稿定设计会员，成为会员即视为同意<a :href="`${gaodingUrl}/term/membership_service_agreement`" target="_blank"> 会员服务协议</a>
    </div>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
import bemMixin from './bem';
import { getConfig } from './config';
export default {
  name: 'g-auth-footer',
  inject: ['vm'],
  mixins: [bemMixin],
  props: {
    rightType: {
      // 右侧应该展示的按钮类型
      type: String,
      default: 'register' // register: 展示手机号注册

    },
    slotText: String
  },
  computed: {
    gaodingUrl: function gaodingUrl() {
      return getConfig('gaodingURL');
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-footer__footer {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
  left: 0;
  height: 62px;
  width: 100%;
  padding: 0 20px;
  background: linear-gradient(216deg, #f9fafb 0%, #f8fafb 57%, #f0f2f6 100%);
  font-size: 12px;
  color: #9DA3AC;
}
.g-auth-footer__footer a {
  color: #636C78;
}
.g-auth-footer__right {
  display: flex;
  align-items: center;
}
.g-auth-footer__right:hover .g-auth-footer__right-btn {
  font-weight: bold;
  color: #2254F4;
}
.g-auth-footer__hover {
  cursor: pointer;
}
.g-auth-footer__hover:hover .g-auth-footer__right-btn {
  font-weight: bold;
  color: #2254F4;
}
.g-auth-footer__right .g-auth-footer__right-btn {
  font-size: 12px;
  color: #2254F4;
  padding: 0;
  background: transparent;
}
.g-auth-footer__right-icon {
  margin-top: 2px;
  font-size: 20px;
  color: #2254F4;
}
.g-auth-footer__right-text {
  margin-right: 8px;
  color: #A9A9A9;
}

</style>
